"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function BeyondTheMap() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="222783" id="leccellenza-nautica-a-ibiza" className="bg-background text-foreground relative h-screen min-h-[600px] w-full flex items-center justify-center overflow-hidden">
      {}
      <div className="absolute inset-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1673241/img/yacht_ibiza_golden_hour.png)] bg-cover bg-center bg-no-repeat" />

      {}
      <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/40 to-black/20" />

      {}
      <div ref={ref} className={`relative z-10 flex flex-col items-center justify-center text-center px-4 max-w-5xl mx-auto transition-all duration-1000 ease-out transform ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
        <h1 className="font-default text-6xl md:text-7xl lg:text-8xl font-bold text-white drop-shadow-lg mb-6 tracking-tighter uppercase">
          L'ECCELLENZA NAUTICA A IBIZA
        </h1>
        
        <p className="font-default text-lg md:text-2xl text-white/90 mb-12 max-w-2xl font-medium tracking-wide uppercase">
          Consulenza su misura e preventivi in 24 ore.
        </p>

        <Link to="/ContactsPage">
          <Button size="lg" className="text-lg px-10 py-7 rounded-md shadow-lg shadow-primary/20 hover:shadow-xl hover:shadow-primary/40 transition-all duration-300 bg-primary text-primary-foreground hover:bg-primary/90 border-b-2 border-transparent hover:border-secondary">
            Richiedi un preventivo
          </Button>
        </Link>
      </div>

      {}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-3 animate-pulse">
        <span className="font-default text-[10px] uppercase tracking-widest text-secondary font-semibold">
          Scopri di più
        </span>
        <div className="w-[1px] h-16 bg-gradient-to-b from-secondary to-transparent" />
      </div>
    </section>;
}